(function () {
  const MOBILE_BREAKPOINT = 749.98;

  function initFooterAccordions() {
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    document.querySelectorAll('.footer-block--menu').forEach(function (block) {
      const heading = block.querySelector('.footer-block__heading');
      const content = block.querySelector('.footer-block__details-content');

      if (!heading || !content) return;

      content.style.display = 'none';
      heading.setAttribute('aria-expanded', 'false');
      heading.style.cursor = 'pointer';

      heading.addEventListener('click', function () {
        const isOpen = heading.getAttribute('aria-expanded') === 'true';
        heading.setAttribute('aria-expanded', String(!isOpen));
        content.style.display = isOpen ? 'none' : 'block';
        heading.classList.toggle('footer-block__heading--open', !isOpen);
      });
    });
  }

  function destroyFooterAccordions() {
    document.querySelectorAll('.footer-block--menu').forEach(function (block) {
      const heading = block.querySelector('.footer-block__heading');
      const content = block.querySelector('.footer-block__details-content');

      if (!heading || !content) return;

      content.style.display = '';
      heading.removeAttribute('aria-expanded');
      heading.style.cursor = '';
      heading.classList.remove('footer-block__heading--open');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFooterAccordions();
  });

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        destroyFooterAccordions();
      } else {
        destroyFooterAccordions();
        initFooterAccordions();
      }
    }, 150);
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Add placeholder — targets any newsletter form input
    var input = document.querySelector('.newsletter-form__field-wrapper input[type="email"]');
    if (input) {
      input.setAttribute('placeholder', 'Enter your email address');
    }

    // Change subscribe button label
    // Remove SVG and add text label
    var button = document.querySelector('#Subscribe');
    if (button) {
      button.innerHTML = 'Claim my 10% off';
    }

    // Add disclaimer text after newsletter form
    var form = document.querySelector('#contact_form');
    if (form) {
      var disclaimer = document.createElement('p');
      disclaimer.classList.add('newsletter-form__disclaimer');
      disclaimer.innerHTML = 'By signing up, you agree to our <a href="#">Privacy Policy</a>.';
      form.insertAdjacentElement('afterend', disclaimer);
    }
  });
})();